import React, { useContext, createContext } from 'react';

interface GlobalContextData {
  app: string;
}

const GlobalContenxt = createContext<GlobalContextData>(
  {} as GlobalContextData,
);

export const GlobalProvider: React.FC = ({ children }) => {
  return (
    <GlobalContenxt.Provider value={{ app: 'iFPA' }}>
      {children}
    </GlobalContenxt.Provider>
  );
};

export const useGlobalContenxt = (): GlobalContextData => {
  const context = useContext(GlobalContenxt);
  return context;
};
